<template>
  <div class="accordion_select">
    <div v-if="label" class="mb-2">{{ label }}</div>
    <treeselect
      ref="treeSelect"
      :value="treeValue"
      :multiple="true"
      :disable-branch-nodes="false"
      :class="{ 'is-danger': error }"
      :clear-on-select="true"
      :clearable="clearable"
      :placeholder="placeholderCheck"
      :searchPromptText="`Type to Search Speciality or Subspeciality`"
      :default-expand-level="1"
      :disabled="disabled"
      :async="true"
      @input="updateInput"
      :load-options="loadTreeOptions"
      :showCount="true"
      :showCountOf="`ALL_CHILDREN`"
      :loadingText="`Searching...`"
      :defaultOptions="specialitySmartOptions"
      :close-on-select="false"
      :showToolTip="true"
      :valueConsistsOf="valueConsistsOf"
    >
      <div slot="value-label" slot-scope="{ node }">{{ getLabel(node) }}</div>
    </treeselect>
    <small class="has-error" v-if="error">{{ error }}</small>
  </div>
</template>

<script>
const debounce = require("lodash.debounce");
import Treeselect from "@mail2gowthamganesan/techno-vue-treeselect";
import "@mail2gowthamganesan/techno-vue-treeselect/dist/vue-treeselect.css";
// import Treeselect from "@/assets/js/vue-treeselect/dist/vue-treeselect.cjs.js";
// import "@/assets/js/vue-treeselect/dist/vue-treeselect.css";
import _ from "lodash";
import { isObject, isEmptyObjectCheck } from "@/helpers/helper";
export default {
  name: "accordionSelect",
  components: { Treeselect },
  props: {
    name: {
      type: String,
      default: "SelectBox",
    },
    value: {
      type: [Object, String, Number, Array],
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: undefined,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accordionFetchOption: {
      type: Function,
      default: () => {
        console.log("accordionFetchOptions");
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    enableNA: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    specialitySmartOptions: {
      type: Array,
      default: () => [],
    },
    onInput: {
      type: Function,
      default: () => {},
    },
    valueConsistsOf: {
      type: String,
      default: "BRANCH_PRIORITY",
    }
  },
  computed: {
    treeValue() {
      const res = this.value.map((v) => v?.id || v?.code) || [];
      return res;
    },
    placeholderCheck() {
      return this.enableNA && this.disabled ? "N/A" : this.placeholder;
    },
  },
  methods: {
    updateInput(value, instanceID) {
      setTimeout(() => {
        this.$nextTick(() => {
          const res = value.map((e) => e.replace(/[[\]]/g, "").replace("parent-",""));
          this.$emit("input", this.name, res);
        });
      }, 0);
    },
    getCount(node) {
      return node?.raw?.count ? `(${node?.raw?.count})` : "";
    },
    getLabel(node) {
      let res = node;
      if (this.value.length && !(node.label && !node.label.includes("(unknown)")))
        res = this.value.find(
          (v) => v?.id === node?.id || v?.code === node?.id
        );
      const label = res?.label || "";
      return label.replace(" (unknown)", "");
    },
    loadTreeOptions({ action, searchQuery, callback }) {
      const loading = () => void 0;
      this.accordionFetchOption(
        searchQuery.trim(),
        loading,
        this.name,
        callback
      );
    },
  },
};
</script>
<style lang="scss">
.has-error {
  color: red;
}
.is-danger {
  .vs__dropdown-toggle {
    border-color: red;
    box-shadow: none;
    outline: none;
  }
}
.vue-treeselect__multi-value-item {
  color: #333;
  background: #f0f0f0;
  font-size: 14px;
}
.vue-treeselect__value-remove {
  color: #333;
}
.vue-treeselect--focused:not(.vue-treeselect--open) .vue-treeselect__control {
  border-color: #efa3af !important;
  -webkit-box-shadow: 0 0 0 3px #dd36511a;
  box-shadow: 0 0 0 3px #dd36511a;
}
</style>
